import { loginRequest } from "../authConfig";
import * as Constant from '../actions/constants'

// Refactored to module-based singleton to avoid calling hooks in class
let _instance = null;
let _accounts = null;
let _dispatch = null;
let _session = null;

const staticContext = {
  init({ instance, accounts, session, dispatch }) {
    _instance = instance;
    _accounts = accounts;
    _session = session;
    _dispatch = dispatch;
  },

  isTokenExpired() {
    if (_session?.token 
        && _session?.expiry
        && _session.expiry > (new Date(Date.now() + (1000 * 60 * 5)))) {
      return false;
    }
    return true;
  },

  verifyToken() {
    console.log("------BEFORE VERIFY TOKEN SESSION --------");
    console.log(_session);

    if (!_session?.token || this.isTokenExpired()) {
      console.log('Require to get new token');
      const token = this.renewToken();
      if (token !== null) {
        _dispatch({
          type: Constant.GET_AZURE_TOKEN_SUCCESS,
          payload: {
            token: token.accessToken,
            expiry: token.expiresOn
          }
        });
      }
    }

    console.log("------AFTER VERIFY TOKEN SESSION --------");
    console.log(_session);

    return _session;
  },

  renewToken() {
    return _instance.acquireTokenSilent({
      ...loginRequest,
      account: _accounts[0]
    }).catch((error) => {
      // do nothing
    });
  }
};

export default staticContext;
